import React from 'react';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../../fx/FxLog';
import * as FxFetch from '../../../fx/FxFetch';
import { useTranslation } from '../../../hx/useTranslation';
import CxDialog from '../../../cx/CxDialog';
import CxInput from '../../../cx/CxInput';
import CxSnackbar from '../../../cx/CxSnackbar';
import CxDlgAlert from '../../../cx/CxDlgAlert'; 
import '../../../../styles/main.css';


const MxSupplierOTF = (props) => {
  const [{ trans }] = useTranslation();
  const [dlg, setDlg] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);

  const rf_txSupplier = React.useRef(null);
  const rf_txEin = React.useRef(null);
  const rf_txAddress = React.useRef(null);
  const rf_txCity = React.useRef(null);
  const rf_txState = React.useRef(null);
  const rf_txPostalCode = React.useRef(null);
  const rf_txMobile = React.useRef(null);
  const rf_txEmail = React.useRef(null);

  const r_dlg_alert = React.useRef(null); 
  const r_snack_required = React.useRef(null);
  const r_snack_exists = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  React.useImperativeHandle(props.xref, () => {
    return {
      setDlg,
    };
  });

  const formLoad = async () => {
  }

  const formSave = async () => {
    // chequea requeridos
    if (rf_txSupplier.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txSupplier.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    // --- PROCESO DE GUARDADO ---
    setDlg(false); 
    setDisabled(true);

    r_dlg_alert.current.setText(trans('msg.saving'));
    r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
    r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
    r_dlg_alert.current.setHasButtonClose(false);
    r_dlg_alert.current.setOpen(true);

    let txSupplier = rf_txSupplier.current.getVal();
    let txEin = rf_txEin.current.getVal();
    let txAddress = rf_txAddress.current.getVal();
    let txCity = rf_txCity.current.getVal();
    let txState = rf_txState.current.getVal();
    let txPostalCode = rf_txPostalCode.current.getVal();
    let txMobile = rf_txMobile.current.getVal();
    let txEmail = rf_txEmail.current.getVal();

    let record = {};
    record['txSupplier'] = txSupplier;
    record['txEin'] = txEin;
    record['txAddress'] = txAddress;
    record['txCity'] = txCity;
    record['txState'] = txState;
    record['txPostalCode'] = txPostalCode;
    record['txMobile'] = txMobile;
    record['txEmail'] = txEmail;

    Promise.all([FxFetch.doJsonX("suppliers/otf", record)]).then((result) => {
      r_dlg_alert.current.setOpen(false); 

      if (result[0]) {
        if (result[0].theValue === null) {
          // El proveedor ya existe: reabrimos formulario
          setDisabled(false);
          setDlg(true);
          r_snack_exists.current.setVal(trans('msg.x_exists','field.supplier'));
          r_snack_exists.current.setOpen(true);
        } else {
          // Éxito: notificamos al padre y desbloqueamos sin snackbar
          let inSupplier = result[0].theValue;
          if (props.onOk) props.onOk(inSupplier, txSupplier);
          setDisabled(false);
        }
      }
    }).catch((error) => {
      r_dlg_alert.current.setOpen(false);
      setDisabled(false);
      setDlg(true);
      FxLog.errorx("MxSupplierOTF.formSave", error);
    });

  }

  return (
    <div>
      <CxDialog title={trans('field.create_x','field.supplier')} open={dlg} onOk={formSave} onClose={() => setDlg(false)} >

        <CxInput xref={rf_txSupplier} label={trans('field.supplier')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={100} required />
        <CxInput xref={rf_txEin} label={trans('field.ein')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={15} />
        <CxInput xref={rf_txAddress} label={trans('field.address')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={100} />
        <CxInput xref={rf_txCity} label={trans('field.city')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={50} />
        <CxInput xref={rf_txState} label={trans('field.state')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={50} />
        <CxInput xref={rf_txPostalCode} label={trans('field.postal_code')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={10} />
        <CxInput xref={rf_txMobile} label={trans('field.mobile')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={20} />
        <CxInput xref={rf_txEmail} label={trans('field.email')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={255} />

      </CxDialog>

      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_exists} severity="error" />
    </div>
  );

}

export default MxSupplierOTF;